import ApiService from "@/common/api.service";

export default {
  checkCodeWithLocation(accessCode, location_id) {
    return ApiService.query(
      `meetings/check-code-with-location?accessCode=${accessCode}&location_id=${location_id}`
    );
  },
  checkForMeeting() {},
  checkForRooms() {},
  checkMeetingForVlan(session_id) {
    return ApiService.query("meetings/check-meeting-for-vlan/" + session_id);
  },
  doesMacExist() {},
  getMeeting(meeting_id) {
    return ApiService.query(`meetings/get-meeting/${meeting_id}`);
  },
  getMeetingRooms() {},
  getSplashPage(meeting_id) {
    return ApiService.query(`meetings/get-splash-page/${meeting_id}`);
  },
  getMeetingMotd(meeting_id, session_id) {
    return ApiService.query(`meetings/get-meeting-motd/${meeting_id}/${session_id}`);
  }
};
